import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useLayoutEffect, useState } from "react";
import DeliveryTypeScreen from "./DeliveryTypeScreen";
import footerImg from "../../assets/footerLogo.png";
import Menubar from "./Menubar";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateButtonText,
  updateCss,
  updateShopType,
  updateWidgetConfig,
} from "../../store/slice/widgetSetting.slice";
import {
  FetchWidgetConfigDetails,
  getLanguageDetails,
} from "../../api/HorecaWidget.service";
import {
  resetKiosk,
  setLanguageData,
  setWebshopCategoryData,
  setLanguageWords,
  setWebshopLoading,
  setWebshopSettings,
  updateDefaultLanguage,
  updateSelectedMenuItem,
  updateCurrencyData,
  updateWebshopOpeningHours,
  resetWebshop,
  updateDeliveryType,
} from "../../store/slice/Webshop.slice";
import {
  FetchWebShopCategories,
  FetchWebshopSettings,
  getCurrencyData,
  getWebshopOpeningHours,
} from "../../api/Webshop.service";
import { useTheme } from "@emotion/react";
import dayjs from "dayjs";
import MenuItemListComponent from "./MenuItemListComponent";

const WebshopMain = () => {
  const theme = useTheme();

  const [langLoading, setLangLoading] = useState(false);
  const [widgetLoading, setWidgetLoading] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const { key, widgetSetupId, resType,widgetConfig } = useSelector(
    (store) => store?.widgetSettings
  );
  const {
    defaultLanguage,
    webshopLoading,
    shopType,
    languageWords,
    webshopSettings,
  } = useSelector((store) => store?.Webshop);
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);

  const deliveryCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "DeliveryTypeScreen"
  )?.fields
const overallCss= css?.find(
  (item) => item?.cssTabFieldsGroupName === "Overall"
)?.fields

  // get the height of the widget
  const getHeight = () => {
    setTimeout(() => {
      let rootHeight = document.getElementById("root");
      let frameHeight = 200;

      if (rootHeight) {
        if (rootHeight.clientHeight > frameHeight) {
          if (rootHeight.clientHeight > 800) {
            frameHeight = "100vh"; // Cap the height
          }

          if (rootHeight.clientWidth < 700) {
            frameHeight = rootHeight.clientHeight + 100;
          } else {
            frameHeight = rootHeight.clientHeight + 20;
          }
        }
      }
      if (frameHeight < 480) {
        frameHeight = 650;
      }
      send(frameHeight + "px", "100%", "", "0px", "0px", "", "relative");
    }, 100);
  };
  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  useEffect(() => {
    if (resType == "webshop") {
      getHeight();
    }
  }, []);

  const fetchLanguageDetails = async () => {
    dispatch(setWebshopLoading(true));
    try {
      const response = await getLanguageDetails(key);
      if (response?.status != 200) {
        console.error("Error fetching language details widget:", response);
        dispatch(setWebshopLoading(false));
        return;
      }
      dispatch(setLanguageData(response?.data));
      const langParam = queryParams.get("lang");
      if (response?.data) {
        const defaultLang =
          langParam !== null && langParam !== "null"
            ? langParam
            : response?.data?.find((item) => item?.defaultLanguage)?.langcode;
        dispatch(updateDefaultLanguage(defaultLang));
      }
      setLangLoading(false);
    } catch (error) {
      console.error("Error fetching language details widget:", error?.message);
      setLangLoading(false);
      dispatch(setWebshopLoading(false));
    }
  };


  const getCategories = async () => {
    try {
      const response = await FetchWebShopCategories(key, defaultLanguage,widgetSetupId);
      if (response?.status != 200) {
        console.error("Error fetching categories widget:", response);
        return;
      } else {
        dispatch(setWebshopCategoryData(response?.data));
        dispatch(updateSelectedMenuItem(response?.data[0]));
      }
      dispatch(setWebshopLoading(false));
    } catch (error) {
      console.error("Error fetching categories widget:", error?.message);
      dispatch(setWebshopLoading(false));
    }
  };
  const fetchCurrencyData = async () => {
    try {
      const data = await getCurrencyData(key);
      if (data) dispatch(updateCurrencyData(data));
    } catch (error) {
      console.error("Error fetching currency data:", error?.message || error);
    }
  };
  const fetchWebshopSettings = async () => {
    dispatch(setWebshopLoading(true));
    try {
      dispatch(resetKiosk());
      const response = await FetchWebshopSettings(key);
      if (response?.status != 200) {
        console.error("Error fetching settings widget:", response);
        dispatch(setWebshopLoading(false));
        return;
      } else {
        dispatch(setWebshopSettings(response?.data));
      }
      dispatch(setWebshopLoading(false));
    } catch (error) {
      console.error("Error fetching settings widget:", error?.message);
      dispatch(setWebshopLoading(false));
    }
  };
  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      setWidgetLoading(true);
      const response = await FetchWidgetConfigDetails(key, widgetSetupId, lang);
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings details. Please try again later."
        );
      }
      const result = response?.data?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        const data = item.widgetTranslateLanguages[0]?.name;
        acc[tag] = data; // Assign data to the key acc[tag]
        return acc;
      }, {});
      dispatch(updateCss(response?.data?.settings?.cssGroup))
      dispatch(updateWidgetConfig(response?.data));
      dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
      dispatch(setLanguageWords(result));
      setWidgetLoading(false);
    } catch (error) {
      console.error("Error fetching widget settings details:", error);
      setWidgetLoading(false);
    }
  };
  const getOpeningHours = async () => {
    const currentDate = dayjs();
    const response = await getWebshopOpeningHours(
      currentDate.format("YYYY-MM-DD"),
      key
    );
    if (response.success === false) {
      console.error(response.message); // Set the error message
    } else {
      dispatch(updateWebshopOpeningHours(response));
    }
  };

  React.useEffect(() => {
    getOpeningHours();
  }, []);

  useEffect(() => {
    if (key && widgetSetupId && defaultLanguage)
      fetchWidgetSettingsDetails(defaultLanguage);
  }, [defaultLanguage]);

  useEffect(() => {
    if (key) {
      fetchLanguageDetails();
    }
  }, []);

  useEffect(() => {
    if (defaultLanguage) getCategories();
  }, [defaultLanguage]);

  useEffect(() => {
    if (key)
      // Check if key is provided in URL parameters
      fetchWebshopSettings();
  }, [key]);
  useEffect(() => {
    if (key) fetchCurrencyData(key);
  }, []);

const [isInitialized, setIsInitialized] = useState(false);

useEffect(() => {
  if (!webshopLoading && webshopSettings && !widgetLoading && widgetConfig) {
    setIsInitialized(true);
  }
}, [webshopLoading, webshopSettings,widgetLoading]);

useEffect(() => {
  if (
    isInitialized &&
    webshopSettings?.showStartScreen === false
  ) {
    let selectedType = null;
    if (webshopSettings?.hasDelivery) {
      selectedType = "delivery";
    } else if (webshopSettings?.hasPickup) {
      selectedType = "pickup";
    } else if (webshopSettings?.hasDineIn) {
      selectedType = "DineIn";
    }

    if (selectedType) {
      dispatch(updateDeliveryType(selectedType));
    }
    navigate("/webshopMenuItem", { replace: true });
  }
}, [isInitialized,webshopSettings]);

if (!isInitialized) {
    return (
      <Backdrop open sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  


  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: deliveryCss?.deliveryTypeScreenBgClr,
        minHeight: "100vh",
        height: "auto",

        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flex: 1, pt: 5 }}>
      {webshopSettings?.showStartScreen !== false && <DeliveryTypeScreen />}
 
     
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "1rem",
          alignItems: "center",
          justifyContent: { md: "flex-start", sm: "center" },
          px: { xs: 2, md: 4 },
          py: 2,
        }}
      >
        <Box
          sx={{
            flex: "0 1 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={footerImg}
            alt="footerLogo"
            style={{ minWidth: "76px", height: "auto" }}
          />
        </Box>

        <Typography
          sx={{
            flex: "1 1 auto", // Allow the text to grow/shrink
            color: overallCss?.footerTxtClr,
            fontSize: "12px",
            textAlign: "justify",
            maxWidth: { xs: "100%", sm: "70%" }, // Adjust width for small screens
            wordBreak: "break-word", // Handle long text gracefully
          }}
        >
          {languageWords?.FooterInfo}
        </Typography>
      </Box>
    </Box>
  );
};

export default WebshopMain;
